"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var time_span_1 = require("./utils/time_span/time-span");

exports.TimeSpan = time_span_1.TimeSpan;

var type_checking_1 = require("./utils/type-checking/type-checking");

exports.Check = type_checking_1.Check;